import Close16 from '@carbon/icons-react/es/close/16';
// eslint-disable-next-line no-restricted-imports
import { Drawer as AntdDrawer, Tooltip } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

interface CloseIconProps {
  showTooltip: boolean;
}

const CloseIcon: FC<React.PropsWithChildren<CloseIconProps>> = ({
  showTooltip,
}) => (
  <Tooltip
    placement="left"
    data-cy="close.icon"
    title={showTooltip && <FormattedMessage id="esc_to_close" />}
  >
    <Close16 data-cy="close.icon" />
  </Tooltip>
);

export const Drawer = styled(AntdDrawer).attrs<DrawerProps>((props) => {
  const { keyboard = true } = props;

  return {
    closeIcon: <CloseIcon showTooltip={keyboard} data-cy="antd-drawer.close" />,
    mask: false,
    ...props,
  };
})`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
  }
  .ant-drawer-header {
    padding: 0;
    font-size: 16px;
    line-height: 0;
    /* border-bottom: none; */
    /* position: absolute; */
    /* top: 0px;
    right: 0px; */
    /* z-index: var(--zindex-modal-lowest); */
    margin-right: 0px;
  }
  .ant-drawer-close {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    padding: var(--spacing-05);
    margin-right: 0px;
    z-index: var(--zindex-elevated);
    & > span {
      display: flex;
      align-items: center;
    }
    &:hover {
      background-color: var(--black-with-opacity);
    }
  }

  .ant-drawer-body {
    padding: 0;
    overflow: auto;
  }
  /* .ant-drawer-close {
    display: flex;
    padding: var(--spacing-05);
    & > span {
      display: flex;
      align-items: center;
    }
    &:hover {
      background-color: var(--black-with-opacity);
    }
  } */

  .ant-drawer-content-wrapper {
    width: 100%;

    &:before {
      background-color: transparent;
      content: '';
      bottom: 0;
      left: -100vw;
      pointer-events: none;
      position: fixed;
      top: 0;
      transition: background-color ease-in-out var(--animation-duration-medium);
      width: 100vw;
    }

    &:hover:before {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  :root[data-new-theme-enabled='true'] & {
    .ant-drawer-content-wrapper {
      margin: var(--spacing-03);
      border-radius: var(--border-radius-small);
    }

    .ant-drawer-content {
      border-radius: var(--border-radius-small);
      overflow: hidden;
    }
  }

  .ant-drawer-footer {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: var(--layout-02);
    [data-new-theme-enabled='true'] & {
      padding: var(--layout-01);
      border-top: 1px solid var(--scarlet-gray-30);
    }
    > button + button {
      margin-left: var(--layout-01);
    }
  }
`;
